import getScriptData from '@cdo/apps/util/getScriptData';
import {configure} from '@cdo/generated-scripts/studioRoutes';

configure(getScriptData('config'));
